// context/ConfirmationDialogContext.js
import React, { createContext, useContext, useState } from "react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
} from "@chakra-ui/react";

const ConfirmationDialogContext = createContext();

export const useConfirmation = () => {
  const context = useContext(ConfirmationDialogContext);
  if (!context) throw new Error("useConfirmation must be used within ConfirmationDialogProvider");
  return context;
};

export const ConfirmationDialogProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState({});
  const [resolvePromise, setResolvePromise] = useState(null);

  const confirm = (options = {}) => {
    return new Promise((resolve) => {
      setOptions(options);
      setIsOpen(true);
      setResolvePromise(() => resolve);
    });
  };

  const handleConfirm = () => {
    setIsOpen(false);
    resolvePromise?.(true);
  };

  const handleCancel = () => {
    setIsOpen(false);
    resolvePromise?.(false);
  };

  return (
    <ConfirmationDialogContext.Provider value={{ confirm }}>
      {children}

      <AlertDialog isOpen={isOpen} leastDestructiveRef={undefined} onClose={handleCancel}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>{options.title || "Confirmation"}</AlertDialogHeader>
            <AlertDialogBody>{options.message || "Do you want to proceed?"}</AlertDialogBody>
            <AlertDialogFooter>
              <Button onClick={handleCancel}>{options.cancelText || "Cancel"}</Button>
              <Button colorScheme="red" onClick={handleConfirm} ml={3}>
                {options.confirmText || "Confirm"}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </ConfirmationDialogContext.Provider>
  );
};
